export enum EButtonColor {
	inherit = 'inherit',
	green = 'green',
	red = 'red',
	greenOne = 'greenOne',
}

export type TTooltipPosition = 'left' | 'right' | 'above' | 'below'
